"use client";

import React from "react";
import styles from "./index.module.css";
import { Button } from "antd";
import { useRouter } from "next/navigation";

const Pricing = () => {
  const router = useRouter();
  const titleText = "Simple Pricing";
  const subtitleText =
    "Start verifying in minutes — simple setup for your workflow";

  const plans = [
    {
      name: "Try it yourself",
      description:
        "Use our online playground to test VeriID with your own license images — no setup required.",
      features: ["2MB image size limit", "Recognize driver’s licenses"],
      buttonText: "Open Playground",
      buttonType: "default",
      isPro: false,
    },
    {
      name: "$30",
      description:
        "Scale your verification workflows with full API access and monitoring tools.",
      features: [
        "Unlimited API calls",
        "25MB image size limit",
        "Monitor API performance",
        "Cancel anytime",
      ],
      buttonText: "Subscribe",
      buttonType: "primary",
      isPro: true,
      proBadgeText: "Pro",
      secureText: "🔒 Secure payment powered by Stripe",
    },
  ];

  // const enterprise = {
  //   title: "Custom solutions for Enterprise",
  //   description:
  //     "If your business needs large-scale verification, custom API integrations, or added features, reach out — we’ll help you build a plan that fits perfectly.",
  //   buttonText: "Talk to Sales",
  // };

  return (
    <div className={styles.background}>
      <section className={styles.pricing}>
      <h2>{titleText}</h2>
      <p>{subtitleText}</p>
      <div className={styles.plans}>
        {plans.map((plan, index) => (
          <div
            className={`${styles.plan} ${
              plan.isPro ? styles.pro : styles.free
            }`}
            key={index}
          >
            {plan.isPro && (
              <div className={styles.proBadge}>{plan.proBadgeText}</div>
            )}
            <h3>
              {plan.name}
              {plan.isPro && <span className={styles.perMonth}>per month</span>}
            </h3>
            <p>{plan.description}</p>
            <ul>
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <img src="/images/home/check-icon.svg" alt="check icon" />
                  <p>{feature}</p>
                </li>
              ))}
            </ul>
            <Button
              type={plan.buttonType as any}
              onClick={() => router.push(plan.isPro ? "/login" : "/playground")}
            >
              {plan.buttonText}
            </Button>
            {plan.secureText && (
              <p className={styles.secure}>{plan.secureText}</p>
            )}
          </div>
        ))}
      </div>
      {/*<div className={styles.enterprise}>*/}
      {/*  <div>*/}
      {/*    <h3>{enterprise.title}</h3>*/}
      {/*    <p>{enterprise.description}</p>*/}
      {/*  </div>*/}
      {/*  <Button*/}
      {/*    type="primary"*/}
      {/*    style={{*/}
      {/*      background: "#4A6FFF",*/}
      {/*      margin: "0 0.5rem",*/}
      {/*      fontSize: "1rem",*/}
      {/*      padding: "1rem 2rem",*/}
      {/*      height: "auto",*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {enterprise.buttonText}*/}
      {/*  </Button>*/}
      {/*</div>*/}
      </section>
    </div>
  );
};

export default Pricing;